import React from 'react'

function DM_program_details() {
  return (
    <div>
      {/* ---------------------Mobile view------------------ */}
      <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Mastering Marketing Magic!</h1>
                    <p className='py-2'>Dive into the digital realm with our Digital Marketing course. Unleash your potential, learn strategic skills, and enrol now for a bright future in the dynamic world of marketing!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>With the help of our extensive Digital Marketing course, take a fascinating voyage into the digital world. Examine the nuances of email and content marketing, from SEO and social media marketing to designing and creating advertisements. Explore strategies for Quora marketing, Paid Social & Search Advertising, Affiliate marketing, and Freelancing. Discover the potential of mobile marketing, gain an understanding of Google Analytics, and apply what you've learned to practical Minor and Major projects. Advance your professional status in the dynamic field of digital marketing. Come redefine your digital capabilities with us!</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Digital Marketing</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
      </div>

      {/* ------------------------Desktop view-------------- */}
      <div className='d-none d-md-block'>
        <div className='container'>
          <div className='row'>
              <div className='col-md-8 detail_1stcomp_img'>
                  <div className='pt-3 Program_details_1stcomp_text'>
                      <h1 className='display-6'>Mastering Marketing Magic!</h1>
                      <p className='py-4'>Dive into the digital realm with our Digital Marketing course. Unleash your potential, learn strategic skills, and enrol now for a bright future in the dynamic world of marketing!</p>
                  </div>
                  <div className='mt-3 Program_details_1stcomp_text'>
                      <h1 className='display-3'>Overview</h1>
                      <p className='py-4'>With the help of our extensive Digital Marketing course, take a fascinating voyage into the digital world. Examine the nuances of email and content marketing, from SEO and social media marketing to designing and creating advertisements. Explore strategies for Quora marketing, Paid Social & Search Advertising, Affiliate marketing, and Freelancing. Discover the potential of mobile marketing, gain an understanding of Google Analytics, and apply what you've learned to practical Minor and Major projects. Advance your professional status in the dynamic field of digital marketing. Come redefine your digital capabilities with us!</p>
                  </div>
              </div>
              <div className='col-md-4'>
                  <div>
                  <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                  <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Digital Marketing</h1>
                    <div className='Details_text '>
                      <ul className='pt-4'>
                        <li>Live conversations with industry professionals</li>
                        <li className='py-3'>Project support and Guidance</li>
                        <li>Access to Specialized Course Materials</li>
                        <li className='py-3'>25+ Hours of Learning</li>
                        <li>Certificates from reputable MNC's around the world</li>
                      </ul>
                    </div>
                    <div className='text-center'>
                    {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                    </div>
                  </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DM_program_details
